// test1477
(1477 && 0);
